<template lang="pug">
  div.garbage.organization-update
    e-form-modal(
      ref="modalForm"
      @submitModalForm="sendForm()"
      @deleteItem="deleteItem()"
      :hideDeleteButton="(!!fields.id)"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
        e-form-tabs(
          v-model="tabView"
          :tabs="tabs"
        )
      slot
        e-form(:formValidator="formValidator")
          // вкладка ОБЩИЕ СВЕДЕНИЯ
          div(v-show="tabView === 'tab1'")
            input(type="hidden" v-model="fields.parent_id")
            div.body
              div.col
                e-form-subtitle(text="Реквизиты")
                
                e-form-group(
                  name="name"
                  inputType="name"
                  label="Наименование"
                  :model="fields"
                  :required="true"
                  tabView="tab1"
                )
                e-form-group(
                  name="room_count"
                  label="Количество номеров"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="bed_count"
                  label="Количество койко-мест"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="hotel_period_type_id"
                  inputType="select"
                  label="Период функционирования"
                  :model="fields"
                  tabView="tab1"
                  :options="hotelPeriodTypes"
                )
                e-form-group(
                  name="status_id"
                  inputType="select"
                  :required="true"
                  label="Статус объекта"
                  :model="fields"
                  tabView="tab1"
                  :options="statuses"
                )
                e-form-group(
                  name="close_date"
                  inputType="calendar"
                  label="Дата закрытия"
                  :model="fields"
                  tabView="tab1"
                  :disabled="fields.status_id !== notActive"
                )
              
              div.col
                e-form-subtitle(text="Вид деятельности по ОКВЭД")
                e-form-group(
                  name="code"
                  inputType="input"
                  label="ОКВЭД(номер)"
                  :model="fields.okved"
                  validateAlias="okved.code"
                  tabView="tab1"
                )
                e-form-group(
                  name="name"
                  inputType="input"
                  label="ОКВЭД(наименование)"
                  :model="fields.okved"
                  validateAlias="okved.name"
                  tabView="tab1"
                )
                e-form-group(
                  name="business_category_id"
                  inputType="select"
                  label="Отношение к субъектам предпринимательства"
                  :model="fields"
                  tabView="tab1"
                  :options="business_categories"
                )
                e-form-group(
                  name="activity_description"
                  inputType="textarea"
                  label="Краткое описание деятельности"
                  :model="fields"
                  tabView="tab1"
                )
                
                e-form-subtitle(text="Руководитель")
                e-form-group(
                  name="head_position"
                  inputType="input"
                  label="Должность"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="head_name"
                  inputType="input"
                  label="ФИО"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="head_phone"
                  inputType="input"
                  validationRule="phone"
                  label="Телефон"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="head_email"
                  inputType="input"
                  validationRule="email"
                  label="Email"
                  :model="fields"
                  tabView="tab1"
                )
              
              
              div.col
                e-form-subtitle(text="Местоположение")
                e-location(
                  :formValidator="formValidator"
                  :model="fields"
                  name="fact_address"
                  :required="true"
                  :addressData="addressData"
                  addressIdFieldName="fact_address_id"
                  tabView="tab1"
                )
                
                e-form-subtitle(text="Ответственный за экологию")
                e-form-group(
                  name="eco_position"
                  inputType="input"
                  label="Должность"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="eco_name"
                  inputType="input"
                  label="ФИО"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="eco_phone"
                  inputType="input"
                  label="Телефон"
                  validationRule="phone"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="eco_email"
                  inputType="input"
                  validationRule="email"
                  label="Email"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="photoPreview"
                  inputType="simple-file-uploader"
                  label="Фотография"
                  :model="fields"
                  tabView="tab1"
                  :uploadUrl="uploadUrl"
                  @fileUploaded="fileUploaded"
                  @fileRemoved="fileRemoved"
                  :showFilePreview="true"
                )
          
          // вкладка ОТХОДЫ
          div(v-if="tabView === 'tab3'")
            garbage-table(:id="fields.id" ref="garbageTable" tabView="tab3")
          
          // вкладка ОПЕРАТОРЫ
          div(v-show="tabView === 'tab4'")
            operator-table(:id="fields.id" ref="operatorTable" tabView="tab4")
          
          // Маршруты
          div(v-if="tabView === 'routes'").routes
            routes-table(:fields="fields" :id="fields.id" ref="routesTable" tabView="routes")
          
          //Журнал изменений
          div(v-show="tabView === 'tab5'")
            change-log-tab(
              :entityId="fields.id"
              :moduleId="moduleId"
            )
          //Документы
          div(v-show="tabView === 'tab6'")
            documents-table(
              :document-ids="documentIds"
              @documentsChanged="documentsChanged"
            )
</template>

<script>
  import garbageForm                  from '../mixins/garbage-form.js'
  import { GARBAGE_TYPE_HEALTH_RESORT } from '@/config/config'
  
  export default {
    mixins: [garbageForm],
    data() {
      return {
        tabView: 'tab1',
        fields:  {
          status_id:                  '',
          business_category_id:       '',
          latitude:                   '',
          longitude:                  '',
          garbage_source_type_id:     GARBAGE_TYPE_HEALTH_RESORT,
          garbage_source_category_id: ''
        },
        errors:  null
      }
    },
    computed: {
      moduleId() {
        return this.moduleIds['garbage-source']
      },
      tabs() {
        const tabs = [
          { tab1: 'Общие сведения' },
          { tab3: 'Отходы' },
          { tab4: 'Операторы' },
          { routes: 'Маршруты' }
        ]
        if (this.fields.id) {
          tabs.push({ tab5: 'Журнал изменений' })
        }
        tabs.push({ tab6: 'Документы' })
        return tabs
      },
      hotelPeriodTypes() {
        return [
          {id: 1, name: 'Сезонно'},
          {id: 2, name: 'Круглосуточно'},
          {id: 3, name: 'Сезонно с возможностью работать круглосуточно'},
        ];
      }
    }
  }
</script>
